import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
    selector: 'app-iframe-dialog',
    templateUrl: './iframe-dialog.component.html',
    styleUrls: ['./iframe-dialog.component.scss'],
    standalone: false
})
export class IframeDialogComponent implements OnInit {
  qrValue: string;
  headerText = (localStorage.getItem('lang') === 'es') ? 'Código QR' : 'QR Code';
  closeText = (localStorage.getItem('lang') === 'es') ? 'CERRAR' : 'CLOSE';

  constructor(public dialogRef: MatDialogRef<IframeDialogComponent>,
              @Inject(MAT_DIALOG_DATA) public data: any, ) {
                dialogRef.disableClose = true;
              }

  ngOnInit(): void {
  }

  close() {
    this.dialogRef.close();
  }

}
